
export default {
  props: {
    offers: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      selectedOffers: [],
      selectedCategories: [],
    };
  },
  computed: {
    offerCategories () {
      return this.offers.map(item => item.terms).flat();
    },
    categoryList () {
      if (!this.offerCategories.length) return [];
      const allCategories = this.offerCategories.filter(cat => cat.term_id);
      const categoryList = allCategories.map(cat => ({
        name: cat.name,
        slug: cat.slug,
      }));
      const uniqueCategoryList = [
        ...new Map(categoryList.map(cat => [cat.slug, cat])).values(),
      ];
      return [...uniqueCategoryList].sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  watch: {
    selectedCategories: {
      immediate: true,
      handler (selectedCategories) {
        if (!selectedCategories.length) { return (this.selectedOffers = [...this.offers]); }
        this.selectedOffers = [...this.offers].filter(offer => offer?.terms &&
        offer.terms.some(
          category =>
            selectedCategories.find(
              selectedCategory => selectedCategory.slug === category.slug,
            ) || null,
        ));
      },
    },
    selectedOffers: {
      immediate: true,
      handler (selectedOffers) {
        this.$emit(`selectedOffers`, selectedOffers);
      },
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.reset();
    });
  },
  methods: {
    // INTERFACES:
    reset () {
      this.selectedCategories = [];
      this.selectedOffers = [...this.offers];
    },
    // ABSTRACTION BARRIER:
  },
};
